export default __webpack_public_path__ + "static/Milan-Laser-Hair-Removal-Celebrates-Opening-of-400th-Clinic-75a68d36be77ded039cbaf33fa69af6d.pdf";